import PropTypes from 'prop-types';
import {Icon} from 'front-onceforall-core';

function InformationMessageView({message}) {
  if (!message) {
    return null;
  }

  return (
    <div className="box primary mb-5 w-100 d-flex align-items-center">
      <div className="active mr-4">
        <Icon
          icon="info"
          size={28}
        />
      </div>
      <div style={{whiteSpace: 'pre-line'}}>
        {message}
      </div>
    </div>
  );
}

InformationMessageView.propTypes = {
  message: PropTypes.string
};

export default InformationMessageView;
